import React, { Component } from "react";
import "./member.scss";
import { Toast, WhiteSpace, WingBlank, Button } from "antd-mobile";
import Uheader from "../Goolbal/Uheader";
import jindou from "../assets/jindou.png";
import gongnneg from "../assets/gongnneg.png";
import biaoge from "../assets/biaoge_02.jpg";
// import biaoge2 from "../assets/biaoge_022.png";
import axios from "../axios";

var u = navigator.userAgent;
var isAndroid = u.indexOf("Android") > -1;
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

class member extends React.Component {
  state = {
    Package: [
      // {
      //   costPrice: "48",
      //   discount: "1",
      //   nowPrice: "48",
      //   payValid: "3",
      //   title: ""
      // },
      // {
      //   costPrice: "96",
      //   discount: "0.9",
      //   nowPrice: "86.4",
      //   payValid: "6",
      //   title: "推荐"
      // },
      // {
      //   costPrice: "192",
      //   discount: "0.8",
      //   nowPrice: "153.6",
      //   payValid: "12",
      //   title: "超值优惠"
      // },
    ],
    privilege: [
      
    ],
    footList: [
      {
        Amount: "累计充值积分",
        grade: "会员等级",
        discount: "金豆购买折扣",
      },
      {
        Amount: "0~665积分",
        grade: "白银",
        discount: "9.8折",
      },
      {
        Amount: "666~1687积分",
        grade: "黄金",
        discount: "9.5折",
      },
      {
        Amount: "1688~5188积分",
        grade: "钻石",
        discount: "9.2折",
      },
      {
        Amount: "5188积分以上",
        grade: "皇冠",
        discount: "8.8折",
      },
    ],
    assets: [
      //资产
      {
        img: jindou,
        title: "金豆",
        content: "剩余：12567",
        btn: "我的金豆",
      },
      {
        img: gongnneg,
        title: "功能券",
        content: "匿名、标题变色、闪买、闪卖、置顶等会员专享功能",
        btn: "我的功能券",
      },
    ],
    MemberPackage: {},
    tab: "tab-0", //选中颜色高亮Package
    Mymember: true, //是否是会员
    resultObject: {}, //接口信息哦
    userimgUrl: null,
	isFlagship: "N",	//是否为旗舰店，Y=是的，N=否
	isShowFlagship: "Y",	//是否显示旗舰店，Y=显示，N=不显示
  };
  Discoloration = (item, key) => {
    console.log(item, key);
    this.setState({
      tab: `tab-${key}`,
      MemberPackage: item,
    });
  };
  
  flagshipClick = () => {
	  //开通旗舰店
	  if (isiOS) {
	    try {
	      window.webkit.messageHandlers.IOSNativeBuyFlagShip.postMessage("");
	    } catch (e) {
	      console.log(e);
	    }
	  } else {
	    try {
	      window.app.androidBuyFlagShip("");
	    } catch (e) {
	      console.log(e);
	    }
	  }
  };

  MymemberClick = () => {
    //  console.log(u)
    var arr = Object.keys(this.state.MemberPackage);
    if (!arr.length) {
      // return;
      Toast.fail("请选择套餐内容", 2);
      return;
    }
    console.log(this.state.MemberPackage);
    if (this.state.Mymember === true) {
      console.log("会员");
      let obj = {
        code: this.state.MemberPackage.payValid, //月数
        Quantity: this.state.MemberPackage.nowPrice, //金额
        beanCount: `${this.state.resultObject.beanCount}`, //个人金豆数量
        beanPrice: `${this.state.resultObject.beanPrice}`, //钱都换算比例
		beanDiscount: `${this.state.resultObject.beanDiscount}` || '0',//钱豆混合的比例
        payway: (this.state.resultObject.beanDiscount && this.state.resultObject.beanDiscount > 0)?"2":"1", //1钱 2钱豆   支付方式
      };
      let MYdata = JSON.stringify(obj);
      if (isiOS) {
        try {
          window.webkit.messageHandlers.IOSNativeBuyMember.postMessage(obj);
        } catch (e) {
          console.log(e);
          setTimeout(function () {
            Toast.fail("请升级最新版本,当前版本过低暂不支持此功能", 3);
          }, 2000);
        }
      } else {
        try {
          window.app.androidBuyMembership(MYdata);
          // this.setState({
          //   Show: "none"
          // });
        } catch (e) {
          //TODO handle the exception
          // console.log(e);
          setTimeout(function () {
            Toast.fail("请升级最新版本,当前版本过低暂不支持此功能", 3);
          }, 2000);
        }
      }
    } else {
      console.log("不是会员");
      let obj = {
        code: this.state.MemberPackage.payValid,
        Quantity: this.state.MemberPackage.nowPrice,
        beanCount: `${this.state.resultObject.beanCount}`,
        beanPrice: `${this.state.resultObject.beanPrice}`,
		beanDiscount: `${this.state.resultObject.beanDiscount}` || '0',//钱豆混合的比例
        payway: (this.state.resultObject.beanDiscount && this.state.resultObject.beanDiscount > 0)?"2":"1", //1钱 2钱豆   支付方式
      };
      let MYdata = JSON.stringify(obj);
      if (isiOS) {
        try {
          window.webkit.messageHandlers.IOSNativeBuyMember.postMessage(obj);
          // window.webkit.messageHandlers.IOSNativePayBond.postMessage(50);
        } catch (e) {
          console.log(e);
        }
      } else {
        try {
          window.app.androidBuyMembership(MYdata);
        } catch (e) {
          console.log(e);
        }
      }
    }
  };
  BuyGoldBean = (item, key) => {
    console.log(item, key);
    if (key === 0) {
      //购买金豆
      if (isiOS) {
        try {
          window.webkit.messageHandlers.IOSNativeBuyGoldBean.postMessage("");
          // window.webkit.messageHandlers.IOSNativePayBond.postMessage(50);
        } catch (e) {
          console.log(e);
        }
      } else {
        try {
          window.app.androidBuyGoldBean("");
        } catch (e) {
          console.log(e);
        }
      }
    } else {
      //我的功能卷
      if (isiOS) {
        try {
          window.webkit.messageHandlers.IOSNativeBuyFunctionBond.postMessage(
            ""
          );
        } catch (e) {
          console.log(e);
        }
      } else {
        try {
          window.app.androidGotoFunctionTicket("");
        } catch (e) {
          console.log(e);
        }
      }
    }
  };
  onClose = () => {};
  componentWillMount() {
    // Toast.loading('正在加载，请稍后...', 0);
    // Toast.loading('正在加载，请稍后...', 0,this.onClose,false);
 
  }
  // js比较两个数组对象,取出key相同的并push进同一数组

  componentDidMount() {
    //DOM加载完执行 类似于mounted
    const _this = this;
    axios
      .post("/user/json/getMemberInfor", {
        userId: _this.props.match.params.userId,
      })
      .then(function (response) {
        if (response.data.code === 10000) {
          // userType 2- 已经认证,未开通会员     1-注册 3-白银4-黄金5-钻石6-皇冠

          let userType, userimgUrl;
          if (
            response.data.resultObject.userType === "1" ||
            response.data.resultObject.userType === "2"
          ) {
            userType = false; //不是会员
          } else {
            userType = true; //会员

            // this.state.resultObject.userType == 3?
            // <img src={require("../assets/silver.png")} alt="" />:
            //  this.state.resultObject.userType == 4?
            //  <img src={require("../assets/gold.png")} alt="" /> :
            //  this.state.resultObject.userType == 5?
            //  <img src={require("../assets/diamond.png")} alt="" /> :
            //  this.state.resultObject.userType == 6?
            //  <img src={require("../assets/Crown.png")} alt="" /> :null

            if (response.data.resultObject.userType == 3) {
              userimgUrl = require("../assets/silver.png");
            } else if (response.data.resultObject.userType == 4) {
              userimgUrl = require("../assets/gold.png");
            } else if (response.data.resultObject.userType == 5) {
              userimgUrl = require("../assets/diamond.png");
            } else if (response.data.resultObject.userType == 6) {
              userimgUrl = require("../assets/Crown.png");
            }
          }
        //   console.log(this.state.privilege)
        //   console.log(packages)
        let list=[
          {
            time: "1个月",
            payValid:'1',
            content: ['匿名1次','标题变色1次','闪买1次','闪卖1次','置顶1次'],
          },
          {
            time: "3个月",
            payValid:'3',
            content: ['匿名3次','标题变色3次','闪买3次','闪卖3次','置顶3次'],
          },
          {
            time: "6个月",
            payValid:'6',
            content: ['匿名6次','标题变色6次','闪买6次','闪卖6次','置顶6次'],
          },
          {
            time: "1年",
            payValid:'12',
            content: ['匿名15次','标题变色15次','闪买15次','闪卖15次','置顶15次'],
          },
        ]
        let data=JSON.parse(response.data.resultObject.jsonStr)
        var yearList=[]
        for(let i = 0; i < data.length; i++){
          let obj = data[i],
           num = obj.payValid, 
           flag = false;
          for(let j = 0; j < list.length; j++){
              let aj = list[j]
             let n = aj.payValid, 
              yearObj = {};
              
              //如果detime对应匹配
              if(n === num){
                flag = true;
                yearObj = list[j]
                
                yearList.push(yearObj);
              }else{
                 flag = false;
              }
           }
       }
       

 

          _this.setState({
            resultObject: response.data.resultObject,
			Package: JSON.parse(response.data.resultObject.jsonStr),
      privilege:yearList,
			MemberPackage:JSON.parse(response.data.resultObject.jsonStr)[0],
            assets: [
              //资产
              {
                img: jindou,
                title: "金豆",
                content: `剩余：${response.data.resultObject.beanCount}`,
                btn: "购买金豆",
              },
              {
                img: gongnneg,
                title: "功能券",
                content: "匿名、标题变色、闪买、闪卖、置顶等会员专享功能",
                btn: "我的功能券",
              },
            ],
            Mymember: userType,
            userimgUrl: userimgUrl,
			isFlagship: response.data.resultObject.isFlagship,
			isShowFlagship : response.data.resultObject.isShowFlagship
          });
          
   
         
          
        } else {
          _this.setState({
            isLoaded: false,
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
   
     
        
   
  }
  render() {
    
    return (
      <div className="mymember">
        {/* <Uheader utitle="会员信息"></Uheader> */}
        <header>
          <div className="header_home">
            <div className="header_left">
              <img
                src={
                  this.state.resultObject.portrait ||
                  "http://image.ybk008.com/2442e653c60be98c37a2945b6015e941571110502565"
                }
                className="userAvatar"
              />
              <ul>
                <li>
                  <h1>
                    {this.state.resultObject.nickName}
                    {this.state.Mymember ? (
                      <img src={this.state.userimgUrl} alt="" />
                    ) : null}
                  </h1>

                  <span className="Grand">累计充值金额</span>
                </li>
                <li>
                  <p>{this.state.resultObject.timeStr}</p>

                  <p className="Amount">
                    ￥<span>{this.state.resultObject.price}</span>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </header>
        <main>
          <div className="Membership">
            <p className="Membership_title">会员优惠套餐</p>
            <ul>
              {this.state.Package.map((item, key) => (
                <li
                  key={key + 150}
                  className={this.state.tab === `tab-${key}` ? "active" : null}
                  onClick={() => this.Discoloration(item, key)}
                >
                  <p>{item.payValid}个月</p>
                  <div className="price">
                  {item.discount < 1 ? (
                    <p className={key === 0 ? "Myhide" : null}>
                      原价:{item.costPrice}元
                    </p>
                  ) : <p className={key === 0 ? "Myhide" : null}>
                    </p>}
                    
                    <p>
                      <span>￥<span>{item.nowPrice}</span></span>
                      {/* <span>元</span> */}
                    </p>
                    
                  </div>
                  {(item.title && item.discount < 1) ? (
                    <div className="beijing">{item.title}</div>
                  ) : null}
                  {item.discount < 1 ? (
                    <p className="discount">{item.discount * 10}折</p>
                  ) : null}
                </li>
              ))}
            </ul>
            <button onClick={() => this.MymemberClick()}>
              {this.state.Mymember ? "会员续费" : "开通会员"}
            </button>
          </div>
		  {this.state.isShowFlagship==='Y'? (
			<div className="flagship">
        <h5 className="memberTitle">旗舰店优惠套餐</h5>
				{/* <h4>{this.state.isFlagship=='Y'?'旗舰店续费':'开通旗舰店'}免费送会员</h4> */}
				{/* <h5>会员、旗舰店双重身份</h5> */}
        <div className="member-bgd">
          <div>
            <p>12个月<span><span>￥</span>3000</span></p>
            <p>自动获得会员身份</p>
          </div>
				  <div className="flagBtn" onClick={() => this.flagshipClick()}>{this.state.isFlagship==='Y'?'旗舰店续费':'开通旗舰店'}</div>
        </div>
			  </div>
		  ):null}
		  
          {this.state.Mymember ? (
            <div className="grade">
              <p className="grade_title">我的会员等级</p>
              <footer>
                <ul>
                  {this.state.footList.map((item, key) => 
                  key === 0 ? <li key={key + 1000}>
                        <p>{item.Amount}</p>
                        <p>{item.grade}</p>
                        <p>{item.discount}</p>
                      </li> : Number(this.state.resultObject.userType) >= 3 && this.state.resultObject.userType == key + 2 ?
                    <li key={key + 1000}>
                            <p>{item.Amount}</p>
                            <p>{item.grade}</p>
                            <p>{item.discount}</p>
                    </li>:null
                  )}
                </ul>
              </footer>
              <p className="user_message">注: 1积分 等于 1元</p>
            </div>
          ) : null}
          {this.state.Mymember ? (
            <div className="user_assets">
              <p className="user_assets_title">我的资产</p>
              <ul>
                {this.state.assets.map((item, key) => (
                  <li key={key + 11105}>
                    <div className="user_left">
                      <img src={item.img} alt="" />
                      <div>
                        <p>{item.title}</p>
                        <p>{item.content}</p>
                      </div>
                    </div>
                    <div className="user_right">
                      <button onClick={() => this.BuyGoldBean(item, key)}>
                        {item.btn}
                      </button>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ) : null}
          <div  className={this.state.privilege.length<=3 ? 'privilege' :'adaptive adaptiveLi'}>
            <p className="privilege_title">会员特权</p>
            <p className="privilege_content">
              充值会员即送海量功能券、金豆最高可享受：<span>8.8折</span>
            </p>
            <ul >
              {this.state.privilege.map((item, key) => (
                <li  key={key + 100}>
                  <p>{item.time}</p>
                  <div>{item.content.map((it,index) =>(
                    <nav key={index}>{it}</nav>
                  ))}</div>
                </li>
              ))}
            </ul>
          </div>
          <footer>
            <ul>
              {this.state.footList.map((item, key) => (
                <li key={key + 100010}>
                  <p>{item.Amount}</p>
                  <p>{item.grade}</p>
                  <p>{item.discount}</p>
                </li>
              ))}
            </ul>
          </footer>
          <p className="user_message">注: 1积分 等于 1元</p>
		  <div className="user_assets">
		    <p className="user_assets_title">会员权限表</p>
		    <img className="user_rule_icon" src={biaoge} alt="" />
		    {/* <img className="user_rule_icon" src={biaoge2} alt="" /> */}
		  </div>
        </main>
		
        <div className="zhanwei"></div>
      </div>
    );
  }
}
export default member;
